/**
 * Altered lodash _.flow to sequentially call async functions
 * https://github.com/lodash/lodash/blob/master/flow.js
 *
 * @param {...funcs[]} any functions
 */
export function flowAsync(...funcs: ((...args: any[]) => any)[]): any {
  const length = funcs.length;
  let index = length;
  while (index--) {
    if (typeof funcs[index] !== 'function') {
      throw new TypeError('Expected a function');
    }
  }
  return async function (...args: any[]) {
    let callIndex = 0;
    let result = length ? await funcs[callIndex].apply(null, args) : args[0];
    while (++callIndex < length) {
      if (result) {
        result = await funcs[callIndex].call(null, result);
      }
    }
    return result;
  };
}
